// extracted by mini-css-extract-plugin
export default {"root":"WindowsNotificationArea_root__DyRU0","icon":"WindowsNotificationArea_icon__cxxM9","clock":"WindowsNotificationArea_clock__iwYhL"};